import { LogicService } from './../../services/logic.service';
import { DataSourceService } from './../../services/data-source.service';
import { Component, OnInit, ViewEncapsulation, AfterContentInit, OnDestroy } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../../services/authentication.service';
import { Location } from '@angular/common';
import { UiService } from '../../services/ui.service';
import { EmployeeDataResponse } from '@akiba/models_bimbo';
import { PendingLoanRequestLogicService } from '../../services/pending-loan-request-logic.service';

@Component({
  selector: 'app-root-dashboard',
  templateUrl: './root-dashboard.component.html',
  styleUrls: ['./root-dashboard.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RootDashboardComponent implements OnInit, AfterContentInit {
  loading = false;
  akibaLogoUrl = 'assets/img/miahorro.svg';
  logoCompany = 'assets/img/Logo_Grupo_BIMBO.svg';

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches));
  pendingLoanCount = 0;
  pendingActive = false;


  //////////////////////////////////////
  menuItems: Array<any> = Array<any>();
  sideBarItems: Array<any> = Array<any>();
  //////////////////////////////////////

  principalSubscription: Subscription;
  proxySubscription: Subscription;
  authSubs: Subscription;
  pendingListCountSubs: Subscription;

  constructor(private breakpointObserver: BreakpointObserver,
    private authService: AuthenticationService,
    private location: Location,
    private pendingLoanRequests: PendingLoanRequestLogicService,
    public logicService: LogicService,
    private ui: UiService) {

  }

  ngOnInit() {

  }

  ngAfterContentInit(): void {

    this.principalSubscription = this.logicService.dataManager.principalDataLoader.changes.subscribe(async (e: EmployeeDataResponse) => {

      if (e.response || this.authService.appLevel.currentClaim > 2) {
        await this.loadAccessForEmployee().catch(error => console.log(error));

        if (!this.pendingActive) {
          this.pendingActive = true;
          this.loadPendingLoans();
        }

      }

    });

    this.authSubs = this.authService.authUserSubject.subscribe(anEmployee => {

      if (anEmployee) {

        if (this.logicService.dataManager.principalDataLoader.employee) {
          this.logicService.dataManager.principalDataLoader.employee = null;
        }

        this.logicService.dataManager.principalDataLoader.loadEmployeeFromDataSource(anEmployee.uid);


      }

    });

  }

  async loadAccessForEmployee(): Promise<void> {

    this.ui.stopSpinner();

    return this.authService.appLevel.matchPath(this.location.path()).then(result => {

      if (!result) {
        Promise.reject('The user is not allowed to view this path');
      }

      return;

    }).then(() => {

      this.authService.appLevel.loadAccessForClaim().then(() => {
        this.menuItems = this.authService.appLevel.menuItems;
        this.sideBarItems = this.authService.appLevel.sideBarItems;
        return;

      });

    }).catch(error => {
      this.logOut();
      Promise.reject('The user is not allowed to view this path');
      return;
    });

  }

  logOut() {
    this.authService.signOut();
    this.pendingLoanRequests.stopAllListeners();
  }

  loadPendingLoans() {

    if (this.pendingListCountSubs) {
      this.pendingListCountSubs.unsubscribe();
      this.pendingListCountSubs = null;
    }

    this.pendingListCountSubs = this.pendingLoanRequests.pendingListCountSubject.subscribe(count => {
      this.pendingLoanCount = count;
    });

    switch (this.authService.appLevel.currentClaim) {
      case 2:
        if (this.logicService.dataManager.principalDataLoader && this.logicService.dataManager.principalDataLoader.employee && this.logicService.dataManager.principalDataLoader.employee.workInformation) {
          this.pendingLoanRequests.loadPendingLoans(this.logicService.dataManager.principalDataLoader.employee.workInformation.employeeNumber);
          this.pendingLoanRequests.loadDeniedLoans(this.logicService.dataManager.principalDataLoader.employee.workInformation.employeeNumber);
        }
        break;
      case 3:
      case 4:
        this.pendingLoanRequests.loadAllPendingLoans();
        this.pendingLoanRequests.loadAllLastDeniedLoans();
        break;
    }

  }

  shouldShowBadge(path: string) {
    if (path.includes('supervisor/pending-requests')) {
      return this.pendingLoanCount > 0;
    } else if (path.includes('akiba/pending-requests')) {
      return this.pendingLoanCount > 0;
    } else if (path.includes('administrator/pending-requests')) {
      return this.pendingLoanCount > 0;
    }

    return false;

  }

}
